export function isJwtExpired(token: string) {
  if (!token) return true;

  try {
    const payloadBase64 = token.split('.')[1];
    const decodedPayload = JSON.parse(atob(payloadBase64));

    if (!decodedPayload.exp) return true;

    const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds

    return decodedPayload.exp < currentTime; // true = expired
  } catch (e) {
    console.error('Invalid JWT token:', e);
    return true; // Treat invalid token as expired
  }
}
